import { render, staticRenderFns } from "./VentanaAlGuardar.vue?vue&type=template&id=73374be8"
import script from "./VentanaAlGuardar.vue?vue&type=script&lang=ts"
export * from "./VentanaAlGuardar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports